import type { SearchPreferences, SearchPreferencesUpdate } from "@searchui-searchforms/shared/user-preferences";

/**
 * Optimistically merges a save-preferences payload back into the cached
 * contract selected for the page. This keeps a bfcache-restored form aligned
 * with its save, even when no refetch occurs.
 */
export function mergePayloadIntoPreferences(
    cached: SearchPreferences | null,
    payload: SearchPreferencesUpdate,
): SearchPreferences | null {
    if (cached === null) return cached;

    const merged = { ...cached, ...payload };

    // When the popup count is updated (i.e. user just dismissed it), suppress
    // the popup for this session. The server will re-derive the flag on next
    // full page load using the 24h + count<3 formula.
    if (typeof payload.unviewedFilterPopupShownCount === "number") {
        merged.shouldShowUnviewedFilterPopup = false;
    }

    return merged;
}
